import { IApplicationState } from '../../types/redux';

export const getNewReviewLoading = (state: IApplicationState): boolean => {
  return state.newReview.meta.loading;
};
